import React from 'react';

import Button from '../Button';

import './Section.css';

class SectionItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editAllowed: !props.sensitiveEdit
    };
  }

  allowEdit = () => {
    this.setState({ editAllowed: true });
  };

  render() {
    const { children, buttons, style, contentStyle, overlayStyle, sensitiveEdit } = this.props;
    const { editAllowed } = this.state;
    return (
      <div className="Section-item" style={style}>
        {children && (
          <div className="Section-item-content" style={contentStyle}>
            {typeof children === 'function' ? children(this.state, this.props) : children}
          </div>
        )}
        {buttons && <div className="Section-item-buttons">{buttons}</div>}
        {sensitiveEdit &&
          !editAllowed && (
            <div className="Section-item-overlay" style={overlayStyle}>
              <div className="Section-item-overlay-actions">
                <Button style={{ height: '100%' }} label="I want to edit this" onClick={this.allowEdit} />
              </div>
            </div>
          )}
      </div>
    );
  }
}

export default SectionItem;



// WEBPACK FOOTER //
// ./src/components/basic/section/SectionItem.js